<div class="block h-full rounded-2xl border-16 border-[#B0B8C5] bg-[#B0B8C5]">
  <div
    class="flex h-full flex-col rounded-2xl px-4 py-8"
    [style]="`background: #3559a0;
        background: linear-gradient(90deg, ${backgroundGradient().stop1} 0%, ${backgroundGradient().stop2} 100%);
        box-shadow: 4px 4px 4px 0px ${shadowInsetColor()} inset;
        -webkit-box-shadow: 4px 4px 4px 0px ${shadowInsetColor()} inset;
        -moz-box-shadow: 4px 4px 4px 0px ${shadowInsetColor()} inset;`"
  >
    <ng-content></ng-content>
  </div>
</div>
